import { universalFetch } from "./common";

export const initiateGuestAuth = async (email: string, phone: string) => {
  const normalizedEmail = email.trim().toLowerCase();

  try {
    const response = await universalFetch(
      "/auth",
      "POST",
      { email: normalizedEmail, phone },
      true
    );
    return response;
  } catch (error) {
    console.error("Failed to initiate auth:", error);
    throw error;
  }
};

export const verifyAuth = async (
  phone: string,
  email: string,
  code: string
) => {
  const normalizedEmail = email.trim().toLowerCase();

  try {
    const response = await universalFetch(
      "/auth/verify",
      "POST",
      {
        phone,
        code,
        email: normalizedEmail,
      },
      true
    );
    return response;
  } catch (error) {
    console.error("Failed to verifyAuth:", error);
    throw error;
  }
};
